import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Event, AccessTime, LocationOn } from '@mui/icons-material';

const EventBlock = ({ data, isSelected, onUpdate, previewMode, blockId, onSelectBlock }) => {
  const {
    title = 'Event Title',
    date = new Date().toISOString().split('T')[0],
    time = '19:00',
    location = 'Event Location',
    description = 'Event description...',
    registerLink = '#',
    buttonText = 'Register Now',
    buttonLink = '#',
    backgroundColor = '#ffffff',
    titleColor = '#333333',
    descriptionColor = '#555555',
    dateColor = '#666666',
    buttonBackgroundColor = '#007bff',
    marginTop = 20,
    marginBottom = 20,
    padding = '25px',
    fontFamily = 'Arial, sans-serif',
  } = data;

  const containerStyles = {
    backgroundColor,
    padding,
    borderRadius: '8px',
    marginTop: `${marginTop}px`,
    marginBottom: `${marginBottom}px`,
    border: isSelected ? '2px dashed #007bff' : '1px solid #e0e0e0',
  };

  const titleStyles = {
    fontSize: previewMode === 'mobile' ? '20px' : '24px',
    fontWeight: 'bold',
    color: titleColor,
    marginBottom: '15px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    fontFamily,
  };

  const detailsStyles = {
    display: 'flex',
    flexDirection: previewMode === 'mobile' ? 'column' : 'row',
    gap: previewMode === 'mobile' ? '10px' : '20px',
    marginBottom: '15px',
    flexWrap: 'wrap',
  };

  const detailItemStyles = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '14px',
    color: dateColor,
    fontFamily,
  };

  const descriptionStyles = {
    fontSize: '16px',
    color: descriptionColor,
    lineHeight: 1.6,
    marginBottom: '20px',
    fontFamily,
  };

  const buttonStyles = {
    backgroundColor: buttonBackgroundColor,
    color: '#ffffff',
    padding: '10px 20px',
    fontSize: '14px',
    fontWeight: 'bold',
    textTransform: 'none',
    borderRadius: '5px',
    '&:hover': {
      backgroundColor: buttonBackgroundColor,
      opacity: 0.9,
    },
  };

  const handleButtonClick = (e) => {
    e.preventDefault();
    // Use buttonLink if provided, otherwise fall back to registerLink
    const linkToUse = buttonLink && buttonLink !== '#' ? buttonLink : registerLink;
    if (linkToUse && linkToUse !== '#') {
      window.open(linkToUse, '_blank');
    }
  };

  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    } catch (error) {
      return dateString;
    }
  };

  return (
    <Box
      sx={containerStyles}
    >
      <Typography sx={titleStyles}>
        <Event />
        {title}
      </Typography>
      
      <Box sx={detailsStyles}>
        <Box sx={detailItemStyles}>
          <Event fontSize="small" />
          <span>{formatDate(date)}</span>
        </Box>
        
        <Box sx={detailItemStyles}>
          <AccessTime fontSize="small" />
          <span>{time}</span>
        </Box>
        
        <Box sx={detailItemStyles}>
          <LocationOn fontSize="small" />
          <span>{location}</span>
        </Box>
      </Box>
      
      <Typography sx={descriptionStyles}>
        {description}
      </Typography>
      
      <Button
        sx={buttonStyles}
        onClick={handleButtonClick}
      >
        {buttonText}
      </Button>
    </Box>
  );
};

export default EventBlock; 